import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { PinInput } from 'LocalGluons';
import { useStore } from 'Store';

const PAGES = Object.freeze({
    newPin: 'newPin',
    newPinAgain: 'newPinAgain'
});

const SetPin = ({ onSubmitted, data }) => {
    const { appManager } = useStore();
    const [errorMessage, setErrorMessage] = useState(null);
    const [oldPin, setOldPin] = useState(null);
    const [currentPage, setCurrentPage] = useState(PAGES.newPin);

    const validateNewPinCallback = useCallback((value) => {
        setOldPin(value);
    }, []);

    const validateNewPinAgainCallback = useCallback(
        (value) => {
            if (oldPin !== value) {
                return {
                    errorMessage: t('SETTINGS.CHANGE_PARENTAL_PIN_WRONG_MSG')
                };
            }
            try {
                const { type, code } = data;
                return appManager.api.resetPin({
                    type,
                    code,
                    newPin: value
                });
            } catch (error) {
                return {
                    errorMessage: error.localizedMessage || error.message
                };
            }
        },
        [oldPin]
    );

    const pageComponents = {
        [PAGES.newPin]: (
            <PinInput
                key="set-pin-0"
                header={t('SETTINGS.PARENTAL_NEW')}
                onPinSuccess={() => setCurrentPage(PAGES.newPinAgain)}
                pinValidateFunction={validateNewPinCallback}
                invalidPinMessage={errorMessage}
            />
        ),
        [PAGES.newPinAgain]: (
            <PinInput
                key="set-pin-1"
                header={t('SETTINGS.PARENTAL_NEW_CONFIRM')}
                // old pin here is the saved pin from the first step not the original pin
                onPinSuccess={() => onSubmitted({ ...data, newPin: oldPin })}
                pinValidateFunction={validateNewPinAgainCallback}
                onPinFailed={(message) => {
                    console.log(message);
                    setErrorMessage(message);
                    setCurrentPage(PAGES.newPin);
                }}
            />
        )
    };

    return pageComponents[currentPage];
};

SetPin.propTypes = {
    data: PropTypes.shape({}),
    onSubmitted: PropTypes.func.isRequired
};

export { SetPin };
